import React from 'react';

/**
 * Story 24.35: Collapsed Tab Component
 * Mobile bottom sheet peek state
 */
interface CollapsedTabProps {
  onClick: () => void;
  onMouseDown?: (e: React.MouseEvent) => void;
  onMouseMove?: (e: React.MouseEvent) => void;
  onMouseUp?: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
  onTouchEnd?: (e: React.TouchEvent) => void;
}

export const CollapsedTab: React.FC<CollapsedTabProps> = ({ 
  onClick,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onTouchStart,
  onTouchEnd
}) => {
  return (
    <div 
      className="collapsed-tab" 
      style={{ pointerEvents: 'auto' }} // 6C-5 (Feb 7): Tab itself should be clickable
      onClick={onClick} 
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      role="button" 
      tabIndex={0} 
      aria-label="Expand Emma Assistant"
    >
      <div className="drag-handle" />
      <span>💬 Ask Emma</span>
    </div>
  );
};
